import { Icon } from '@octano/global-ui';
import { Card } from 'reactstrap';
import styles from './TableEmptyContent.module.scss';

interface TableEmpyContent {
  title: string;
  subtitle: string;
  insideCard?: boolean;
  className?: string;
}

const TableEmptyContent = ({
  title,
  subtitle,
  insideCard,
  className,
}: TableEmpyContent) => {
  const Content = () => (
    <div className="d-flex flex-column align-items-center no-result">
      <Icon className="mt-5" name="information" size="52px" color="secondary" />
      <div className="mt-4 fw-400 text-black fs-22 text-center">{title}</div>
      <div
        className={`mx-auto mt-4 mb-5 fs-16 text-center fw-400 ${styles.emptySubtitle}`}
      >
        {subtitle}
      </div>
    </div>
  );

  if (insideCard) {
    return (
      <Card className={`py-4 ${className ?? ''}`}>
        <Content />
      </Card>
    );
  } else {
    return <Content />;
  }
};

export default TableEmptyContent;
